<template>
  <unicom-layout-cartao semFiltro :comPadding="false">
    <div
      style="
        height: 458px;
        display: flex;
        justify-content: center;
        align-items: center;
      "
      class="py-4"
      v-if="loading"
    >
      <unicom-spinner
        :tamanhoLoading="62"
        :tamanhoLinha="7"
        :velocidade="0.5"
        :marginTopTexto="30"
        mensagem="Por favor, aguarde..."
      />
    </div>
    <div style="height: 488px" v-else>
      <div style="max-width: 320px; padding: 32px 32px 24px 32px">
        <unicom-linha :espacamento="false">
          <unicom-coluna sm="auto">
            <unicom-icone class="cor-principal" nome="send" :tamanho="18" />
          </unicom-coluna>
          <unicom-coluna sm="auto" class="pl-2">
            <div class="texto segunda-cor-fonte">Unimed Origem</div>
          </unicom-coluna>
        </unicom-linha>
        <unicom-linha :espacamento="false" style="padding-top: 8px">
          <unicom-coluna sm="auto">
            <div class="subtitulo negrito cor-fonte">
              {{ objetoInformacoes.nomeUnimed }}
            </div>
          </unicom-coluna>
        </unicom-linha>
        <unicom-linha :espacamento="false" style="padding-top: 8px">
          <unicom-coluna sm="auto">
            <div class="texto segunda-cor-fonte">
              Data de envio: {{ objetoInformacoes.dataEnvio }}
            </div>
          </unicom-coluna>
        </unicom-linha>
        <unicom-linha style="padding-top: 12px">
          <unicom-coluna sm="auto">
            <div
              @click="$emit('observacoes')"
              style="letter-spacing: 0.56px"
              class="cor-principal negrito text-underline"
            >
              OBSERVAÇÕES
            </div>
          </unicom-coluna>
        </unicom-linha>
      </div>
      <div class="card-embaixo">
        <unicom-linha :espacamento="false">
          <unicom-coluna sm="auto">
            <div class="segunda-cor-fonte">Nome do arquivo</div>
            <div class="cor-fonte pt-2">
              {{ objetoInformacoes.nomeArquivo }}
            </div>
          </unicom-coluna>
          <unicom-coluna sm="auto" class="ml-auto" style="display: flex">
            <div :style="estiloStatus">{{ textoStatus }}</div>
            <div v-if="isStatusAprovadoErro">
              <unicom-icone
                :style="estiloIconeErroAprovado"
                nome="alert-triangle"
                :tamanho="20"
                tooltipNome="Aprovado com erro"
                localizacaoTooltip="top"
              />
            </div>
          </unicom-coluna>
        </unicom-linha>
        <unicom-linha :espacamento="false" class="pt-4">
          <unicom-coluna sm="auto">
            <div class="segunda-cor-fonte">Número de protocolo</div>
            <div class="cor-fonte pt-2">
              {{ objetoInformacoes.numeroProtocolo }}
            </div>
          </unicom-coluna>
        </unicom-linha>
        <unicom-linha :espacamento="false" class="pt-4">
          <unicom-coluna sm="auto">
            <div class="segunda-cor-fonte">Formato</div>
            <div class="cor-fonte pt-2">TXT</div>
          </unicom-coluna>
        </unicom-linha>
        <unicom-linha :espacamento="false" class="pt-4">
          <unicom-coluna sm="auto">
            <div class="segunda-cor-fonte">Versão</div>
            <div class="cor-fonte pt-2">{{ objetoInformacoes.versao }}</div>
          </unicom-coluna>
        </unicom-linha>
      </div>
    </div>
  </unicom-layout-cartao>
</template>

<script>
import {
  enumStatusValidacao,
  enumStatusValidacaoNome
} from "../../../../shared/helpers/Enum";
export default {
  props: {
    objetoInformacoes: {
      type: Object,
      default: () => {
        return {
          nomeUnimed: "",
          dataEnvio: "",
          status: "",
          nomeArquivo: "",
          numeroProtocolo: "",
          versao: ""
        };
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    /**
     * Computed para consumir o estilo de um dos status usados na validação
     */
    estiloStatus() {
      return this.objetoInformacoes.status
        ? enumStatusValidacao[this.objetoInformacoes.status].estiloTexto
        : "";
    },
    /**
     * Computed para consumir o texto de um dos status usados na validação
     */
    textoStatus() {
      return this.objetoInformacoes.status
        ? enumStatusValidacao[this.objetoInformacoes.status].textoEstilo
        : "";
    },
    isStatusAprovadoErro() {
      return (
        this.objetoInformacoes.status ===
        enumStatusValidacaoNome.APROVADO_COM_ERRO
      );
    },
    estiloIconeErroAprovado() {
      return enumStatusValidacao.APROVADO_COM_ERRO.icones[0].style;
    }
  }
};
</script>

<style lang="scss" scoped>
.card-embaixo {
  height: calc(100% - 200px);
  padding: 32px;
  background: #fcfcfc;
  border-radius: 0px 0px 20px 20px;
  border-top: solid 1px #f2f5f4;
}

.status-arquivo {
  color: white;
  background: rgb(0, 153, 93);
  border-radius: 30px;
  padding: 4px 14px 4px 18px;
  width: 77px;
  text-align: center;
}
</style>
